<script setup>
import { ref, onMounted } from 'vue';

const props = defineProps({
  child:{
    default: Object
  }
})

const isLoading = ref(true)
onMounted(()=>{
  isLoading.value = false
})
</script>

<template>
  <loadingCard v-if="isLoading"/>
  <template v-else>
    <div class="subscribe-package-pill d-flex mt-2">
      <template v-for="report in props.child.reports" :key="report.id">
        <span v-if="report.report.attributes.name" class="badge badge-primary">
          Package {{ report.report.attributes.package_name }}
        </span>
      </template>
    </div>
  </template>
</template>
  